<div class="password-protected-notification">
  <div class="notification-dt">
    <div class="notification-left-container">
      <img src="assets/icons/warning/warning-orange.svg">
    </div>
    <p class="notification-info">

      <strong>Password protected file:</strong> Please remove password protection and re-upload.
      <a href="https://thermofisher.sharepoint.com/sites/GenerativeAICenterofExcellence/SitePages/Education%20%26%20resources/Generative-AI-FAQs.aspx#learn-more-about-the-gene.ai-capabilities"
      target="_blank">See FAQ page</a> for more info.
    </p>
  </div>
</div>
